import React, { Fragment } from "react";

import { string, func } from "prop-types";

import {
  dayOptions,
  monthOptions,
  availabilityYearOptions,
} from "../../../helpers";

import { SelectListGroup } from "../../../common";
import * as style from "./styles.module.scss";

export const availabilityKeys = [
  "availabilityDay",
  "availabilityMonth",
  "availabilityYear",
];

const Availability = ({
  availabilityDay,
  availabilityMonth,
  availabilityYear,
  onChangeHandler,
}) => (
  <Fragment>
    <div className="form-group col-4">
      <div className="form-group text-lightGrey">
        <SelectListGroup
          value={availabilityDay}
          onChange={(e) => {
            onChangeHandler("availabilityDay", e.target.value);
          }}
          options={dayOptions}
          classes={`register_field register_field-dropdown`}
        />
      </div>
    </div>
    <div className="form-group col-4">
      <div className="form-group text-lightGrey">
        <SelectListGroup
          value={availabilityMonth}
          onChange={(e) => {
            onChangeHandler("availabilityMonth", e.target.value);
          }}
          options={monthOptions}
          classes={`register_field register_field-dropdown`}
        />
      </div>
    </div>
    <div className="form-group col-4">
      <div className="form-group text-lightGrey">
        <SelectListGroup
          value={availabilityYear}
          onChange={(e) => {
            onChangeHandler("availabilityYear", e.target.value);
          }}
          options={availabilityYearOptions}
          classes={`register_field register_field-dropdown`}
        />
      </div>
    </div>
  </Fragment>
);

Availability.propTypes = {
  availabilityDay: string.isRequired,
  availabilityMonth: string.isRequired,
  availabilityYear: string.isRequired,
  onChangeHandler: func.isRequired,
};

export default Availability;
